const Images = {
  analyzing: require("./analyzing.png"),
  unclaimedSetupBanner: require("./unclaimed-setup-banner.png"),
  subscriptionBanner: require("./subscription-banner.png"),
  classActionChocolate: require("./welcome/class-action-choco.png"),
  avatar1: require("./welcome/avatar1.jpg"),
  avatar2: require("./welcome/avatar2.png"),
  avatarRv1: require("./welcome/avatar-rv1.png"),
  avatarRv2: require("./welcome/avatar-rv2.png"),
  avatarRv3: require("./welcome/avatar-rv3.png"),
  avatarRv4: require("./welcome/avatar-rv4.png"),
  avatarRv5: require("./welcome/avatar-rv5.png"),
  avatarRv6: require("./welcome/avatar-rv6.png"),
  avatarJenifer: require("./welcome/avatar-jenifer.jpg"),
  avatarAlex: require("./welcome/avatar-alex.jpg"),
  avatarReview1: require("./welcome/avatar-review1.png"),
  avatarReview2: require("./welcome/avatar-review2.png"),
  avatarReview3: require("./welcome/avatar-review3.png"),
  unclaimedTemplate: require("./unclaimed-template.png"),
  logoUber: require("./welcome/logo-uber.png"),
  logoDisneyPlus: require("./welcome/logo-disney-plus.png"),
  logoSpotify: require("./welcome/logo-spotify.png"),
  logoMailchimp: require("./welcome/logo-mailchimp.png"),
  logoUnintedAirlines: require("./welcome/logo-uninted-airlines.png"),
  logoFlight1: require("./welcome/logo-flight1.jpg"),
  logoFlight2: require("./welcome/logo-flight2.jpg"),
  logoFlight3: require("./welcome/logo-flight3.jpg"),
  logoHotel1: require("./welcome/logo-hotel1.jpg"),
  logoHotel2: require("./welcome/logo-hotel2.jpg"),
  logoHotel3: require("./welcome/logo-hotel3.jpg"),
  logoHotel4: require("./welcome/logo-hotel4.jpg"),
  logoHotel5: require("./welcome/logo-hotel5.jpg"),
  logoClassAction1: require("./welcome/logo-class-action1.jpg"),
  logoClassAction2: require("./welcome/logo-class-action2.jpg"),
  logoClassAction3: require("./welcome/logo-class-action3.jpg"),
  logoSub1: require("./welcome/logo-sub1.jpg"),
  logoSub2: require("./welcome/logo-sub2.jpg"),
  logoNetflix: require("./welcome/logo-netflix.jpg"),
  logoOrder1: require("./welcome/logo-order1.jpg"),
  logoOrder2: require("./welcome/logo-order2.jpg"),
  logoOrder3: require("./welcome/logo-order3.jpg"),
  emptyTransactionBlur: require("./empty-transaction-blur.jpg"),
  emptyHalfTransactionBlur: require("./empty-half-transaction-blur.jpg"),
  confetti: require("./confetti.png"),
  notificationBanner: require("./welcome/notification-banner.png"),
  rateUsBanner: require("./welcome/rate-us-banner.png"),
  googlePlay: require("./onboard/brands/DSW.png"),
  clif: require("./onboard/brands/Clif.png"),
  visa: require("./onboard/brands/Visa.png"),
  apple: require("./onboard/brands/Apple.png"),
  bumble: require("./onboard/brands/Bumble.png"),
  breyer: require("./onboard/brands/Breyer.png"),
  mastercard: require("./onboard/brands/Mastercard.png"),
  juul: require("./onboard/brands/Juul.png"),
  walgreens: require("./onboard/brands/Walgreens.png"),
  tMobile: require("./onboard/brands/T-Mobile.png"),
  airbnb: require("./onboard/brands/Airbnb.png"),
  instagram: require("./onboard/brands/Instagram.png"),
  // Brand icons for onboarding slide 3
  brandTMobile: require("./onboard/brand-icons/t-mobile.png"),
  brandJuul: require("./onboard/brand-icons/juul.png"),
  brandApple: require("./onboard/brand-icons/apple.png"),
  brandWalgreens: require("./onboard/brand-icons/walgreens.png"),
  brandBumble: require("./onboard/brand-icons/bumble.png"),
  brandInstagram: require("./onboard/brand-icons/instagram.png"),
  brandVisa: require("./onboard/brand-icons/visa.png"),
  brandMastercard: require("./onboard/brand-icons/mastercard.png"),
  // Hotel brand icons for onboarding slide 4
  brandExpedia: require("./onboard/brand-icons/expedia.png"),
  brandPriceline: require("./onboard/brand-icons/priceline.png"),
  brandHotels: require("./onboard/brand-icons/hotels.png"),
  brandBooking: require("./onboard/brand-icons/booking.png"),
  // Retailer brand icons for onboarding slide 5
  brandWalmart: require("./onboard/brand-icons/walmart.png"),
  brandUberEats: require("./onboard/brand-icons/uber-eats.png"),
  brandTarget: require("./onboard/brand-icons/target.png"),
  brandAmazon: require("./onboard/brand-icons/amazon.png"),
  // Brand icons for onboarding slide 9
  brandSpotifyCircle: require("./onboard/brand-icons/slide9-spotify.png"),
  brandPoppiCircle: require("./onboard/brand-icons/poppi-circle.png"),
  brandNetflixCircle: require("./onboard/brand-icons/slide9-netflix.png"),
  brandAppleCircle: require("./onboard/brand-icons/apple.png"),
  brandAmazonOrange: require("./onboard/brand-icons/amazon-orange.png"),
  manyStars: require("./onboard/many-stars.png"),
  flyMoney: require("./onboard/fly-money.png"),
  claimAlarm: require("./onboard/claim-alarm.png"),
  claimCard: require("./onboard/claim-card.png"),
  brands: require("./onboard/brands.png"),
  reviewCard: require("./onboard/review-card.png"),
  coin3d: require("./onboard/coin-3d.png"),
  logoExpedia: require("./onboard/onboard-logo/expedia.png"),
  logoPriceline: require("./onboard/onboard-logo/priceline.png"),
  logoHotels: require("./onboard/onboard-logo/hotels.png"),
  logoBooking: require("./onboard/onboard-logo/booking.png"),
  logoWalmart: require("./onboard/onboard-logo/walmart.png"),
  logoUberEats: require("./onboard/onboard-logo/uber-eats.png"),
  logoTarget: require("./onboard/onboard-logo/target.png"),
  logoAmazon: require("./onboard/onboard-logo/amazon.png"),
  announcement: require("./announcement.png"),
  rocket: require("./rocket.png"),
  moneyCash: require("./onboard/coin-3d.png"),
  placeholderMyMoney: require("./placeholder-my-money.png"),
  placeholderMyMoneyDesktop: require("./placeholder-my-money-desktop.png"),
  coin3dGlassy: require("./onboard/coin-3d-glassy.png"),
  aiRobot: require("./welcome/ai-robot.png"),
  budgetChart: require("./welcome/budget-chart.png"),
  networthChart: require("./welcome/networth-chart.png"),
  spendingChart: require("./welcome/spending-chart.png"),
  helpIcon: require("../icons/help-icon.png"),
  facebookIcon: require("../icons/facebook.png"),
  youtubeIcon: require("../icons/youtube.png"),
};

export default Images;
